import { CheckCheck, ChevronLeft, ChevronRight } from "lucide-react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Navbar } from "../Component/Navbar";
import { useEffect, useState } from "react";
import hero2 from "../assets/cardiac&travel/hero2.webp";
import ambulance from "../assets/cardiac&travel/ambulance.png";
import slider4 from "../assets/cardiac&travel/slider4.png";
import slider5 from "../assets/cardiac&travel/slider5.png";
import slider6 from "../assets/cardiac&travel/slider6.png";
import bgImg from "../assets/cardiac&travel/bg-img.png";
import Newsletter from "../Component/Home/Newsletter";
import { Footer } from "../Component/Footer";
import {
  Company,
  CompanyAddress,
  Email,
  Phone,
  Contact,
  Officeh,
  Website,
  Geography,
  Industry,
  Serviceh,
  Specialitys,
  Servicea,
} from "../assets/svg";

export default function TravelService({ user, initialTransport }) {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const { id } = useParams();
  const location = useLocation();
  // const [property, setProperty] = useState(location.state || initialTransport);
  const [allServices, setAllServices] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [purchaseStatus, setPurchaseStatus] = useState(null);
  const [transport, setTransport] = useState(location.state || {});
  
  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === transport.uploadFiles.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? transport.uploadFiles.length - 1 : prev - 1
    );
  };

  const handleBreadcrumbClick = () => {
    navigate("/services");
  };

  // converting date to readable data
  const pickUpDate = new Date(transport.vehicleDetails?.pickUpDate);
  const pickUpTime = new Date(transport.vehicleDetails?.pickUpTime);

  // Format the date as YYYY-MM-DD
  const formattedDate = pickUpDate.toISOString().split("T")[0];

  // Format the time as HH:MM:SS
  const formattedTime = pickUpTime.toISOString().split("T")[1].split(".")[0];

  // data added to the fields
  const serviceData = [
    {
      icon: <Company />,
      label: "Company Name",
      value: transport.vehicleDetails?.companions || "NA",
    },
    {
      icon: <CompanyAddress />,
      label: "Pick Up Time",
      value: transport.vehicleDetails?.pickUpTime || "NA",
    },
    {
      icon: <Email />,
      label: "Company Email",
      value: transport.vehicleDetails?.email || "NA",
    },
    {
      icon: <Phone />,
      label: "Company Phone",
      value: transport.vehicleDetails?.phone || "NA",
    },
    {
      icon: <Contact />,
      label: "Companions",
      value: transport.vehicleDetails?.companions || "NA",
    },
    {
      icon: <Officeh />,
      label: "Pick Up Date",
      value: formattedDate || "NA",
    },
    {
      icon: <Website />,
      label: "Website",
      value: transport.vehicleDetails?.website || "NA",
    },
    {
      icon: <Geography />,
      label: "Pick Up Location",
      value: transport.vehicleDetails?.pickUpLocation || "NA",
    },
    {
      icon: <Industry />,
      label: "Industry",
      value: transport.vehicleDetails?.industry1 || "NA",
    },
    {
      icon: <Serviceh />,
      label: "Drop Off Location",
      value: transport.vehicleDetails?.dropOffLocation || "NA",
    },
    {
      icon: <Specialitys />,
      label: "Pick Up Time",
      value: formattedTime || "NA",
    },
    {
      icon: <Servicea />,
      label: "Wait time",
      value: transport.vehicleDetails?.waitTime || "NA",
    },
  ];
  const groupedData = [
    serviceData.slice(0, 4), // First table group
    serviceData.slice(4, 8), // Second table group
    serviceData.slice(8), // Third table group
  ];

  // =================================== Api Integration ===================================
  useEffect(() => {
    if (!id) return;

    const fetchTransport = async () => {
      try {
        const response = await fetch(
          "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/transport-form/get-alluser"
        );
        const data = await response.json();
        const foundTransport = data.transportFormData.find(
          (item) => item._id === id
        );
        if (foundTransport) {
          setTransport(foundTransport); // Set the transport data
        } else {
          console.error("Transport not found");
        }
      } catch (error) {
        console.error("Error fetching transport details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTransport();
  }, [id]);

  // Buy button feature
  const handleBuy = async () => {
    const authToken = localStorage.getItem("authToken"); // Check if the user is logged in

    if (!authToken) {
      setShowPopup(true);
    } else {
      setLoading(true); // Start loading
      try {
        const response = await fetch(
          "https://silver-tlc-backend-delta.vercel.app/api/v1/userpurchase/transport/add",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              token: authToken, // Use the token from localStorage
              transportFormId: transport._id, // Use the property ID from the state
            }),
          }
        );

        const result = await response.json();
        if (response.ok) {
          setPurchaseStatus("success"); // Purchase successful
          console.log("Purchase successful:", result);
        } else {
          setPurchaseStatus("error"); // Purchase failed
          console.error(
            "Purchase failed Login As Individual User",
            result.message
          );
        }
      } catch (error) {
        setPurchaseStatus("error"); // Purchase failed
        console.error("Error during purchase:", error);
      } finally {
        setLoading(false); // Stop loading
      }
    }
  };

  const handlePopupOk = () => {
    // Save the current path and transport data in localStorage
    localStorage.setItem("redirectAfterLogin", location.pathname);
    localStorage.setItem("transportData", JSON.stringify(transport)); // Save transport data
    setShowPopup(false); // Close the popup
    navigate("/login"); // Navigate to the login page
  };
  const handlePopupCancel = () => {
    setShowPopup(false); // Close the popup
  };

  useEffect(() => {
    const redirectPath = localStorage.getItem("redirectAfterLogin");
    const savedTransportData = localStorage.getItem("transportData");

    if (user?.isLoggedIn && redirectPath) {
      try {
        if (savedTransportData) {
          const parsedData = JSON.parse(savedTransportData);
          setTransport(parsedData);
        } else {
          console.warn("No saved transport data found.");
          navigate("/"); // Fallback to home or error page
        }
      } catch (error) {
        console.error("Error parsing saved transport data:", error);
        navigate("/"); // Fallback to home or error page
      } finally {
        localStorage.removeItem("redirectAfterLogin");
        localStorage.removeItem("transportData");
      }
    }
  }, [user, navigate]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="spinner-border text-primary" role="status">
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (!transport) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-gray-500">Transport Service not found.</div>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <div className="min-h-screen">
        {/* Breadcrumbs */}
        <div className="mb-4 text-sm lg:px-24 px-3">
          <button
            onClick={handleBreadcrumbClick}
            className="text-gray-500 hover:text-gray-700"
          >
            General Services
          </button>
          <span className="mx-2 text-gray-400">&gt;</span>
          <span className="text-purple-600 font-medium">Travel Service</span>
        </div>

        {/* Hero Section */}
        <div className="relative w-[90vw] lg:w-[90vw] mx-auto h-[300px] lg:h-[600px] overflow-hidden rounded-3xl shadow-2xl">
          <div
            className="absolute inset-0 bg-cover bg-top"
            style={{
              backgroundImage: `url(${hero2})`,
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-purple-900/60 to-purple-500/40" />
          </div>
          <div className="relative flex h-full items-center justify-center">
            <h1 className="text-3xl lg:text-6xl font-bold text-white tracking-widest">
              Travel Service
            </h1>
          </div>
        </div>

        {/* whole content  */}
        <div className="lg:px-28 px-8">
          <div className="relative">
            {/* Background Image */}
            <div
              className="absolute inset-0 opacity-10"
              style={{
                backgroundImage: `url(${bgImg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "center",
              }}
            ></div>

            {/* Content */}
            <div className="relative py-12">
              <div className="space-y-8">
                {/* Service Description */}
                <div>
                  <h2 className="text-2xl font-bold mb-4">Travel Service</h2>
                  <p className="text-gray-600 leading-relaxed">
                    {transport.vehicleDetails.companions || "NA"} <br />
                    {transport.vehicleDetails.waitTime || "NA"}
                    {transport.vehicleDetails.name || "NA"} <br />
                  </p>
                </div>

                {/* Service Provider */}
                <div>
                  <h2 className="text-2xl font-bold mb-4">Service Provider</h2>
                  <p className="text-gray-600 leading-relaxed">
                    {transport.vehicleDetails.email || "NA"}
                  </p>
                </div>

                {/* Price */}
                <div>
                  <h2 className="text-2xl font-bold mb-4">Price</h2>
                  <p className="text-3xl font-bold text-green-600">
                    ${transport.vehicleDetails.phone}
                  </p>
                </div>
                <div className="mt-6">
                  <button
                    onClick={handleBuy}
                    className="px-6 py-3 bg-purple-600 text-white rounded-full w-full hover:bg-purple-700 transition-all flex items-center justify-center"
                    disabled={loading} // Disable the button while loading
                  >
                    {loading ? (
                      <div className="flex items-center">
                        <svg
                          className="animate-spin h-5 w-5 mr-3 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Processing...
                      </div>
                    ) : (
                      "Buy Now"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Login Required Popup */}
          {showPopup && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white p-6 rounded shadow-lg w-96">
                <h2 className="text-xl font-bold mb-4">Login Required</h2>
                <p className="mb-6">
                  You need to log in before making a purchase.
                </p>
                <div className="flex justify-end space-x-4">
                  <button
                    onClick={handlePopupCancel}
                    className="px-4 py-2 bg-gray-300 text-black rounded hover:bg-gray-400"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handlePopupOk}
                    className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Purchase Status Messages */}
          {purchaseStatus === "success" && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white p-6 rounded shadow-lg w-96">
                <h2 className="text-xl font-bold mb-4">Purchase Successful</h2>
                <p className="mb-6">
                  Your purchase has been completed successfully.
                </p>
                <div className="flex justify-end">
                  <button
                    onClick={() => setPurchaseStatus(null)}
                    className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
                  >
                    <Link to="/Dashboard/services">OK</Link>
                  </button>
                </div>
              </div>
            </div>
          )}

          {purchaseStatus === "error" && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white p-6 rounded shadow-lg w-96">
                <h2 className="text-xl font-bold mb-4">Purchase Failed</h2>
                <p className="mb-6">
                  Please login as an individual account and try again
                </p>
                <div className="flex justify-end">
                  <button
                    onClick={() => setPurchaseStatus(null)}
                    className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* slider with items */}
          <div className="relative bg-white rounded-lg p-6 shadow-sm border w-full">
            {/* Section Header */}
            <div className="flex items-center gap-2 mb-6">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <h2 className="text-lg font-semibold">Service Information</h2>
            </div>

            {/* Carousel Container */}
            <div className="relative flex items-center">
              {/* Left Button */}
              <button
                onClick={prevSlide}
                className="absolute left-0 -ml-5 z-10 rounded-full p-1 bg-gray-100 hover:bg-gray-200 transition shadow"
              >
                <svg
                  width="22"
                  height="16"
                  viewBox="0 0 22 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.292893 7.29289C-0.0976314 7.68342 -0.0976315 8.31658 0.292892 8.7071L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34314C8.46159 1.95262 8.46159 1.31946 8.07107 0.928931C7.68054 0.538407 7.04738 0.538406 6.65686 0.928931L0.292893 7.29289ZM22 7L1 7L1 9L22 9L22 7Z"
                    fill="#7415E2"
                  />
                </svg>
              </button>

              {/* Carousel Container */}
              <div className="overflow-hidden w-full">
                <div
                  className="flex transition-transform duration-300 ease-in-out"
                  style={{
                    transform: `translateX(-${currentSlide * 100}%)`, // Slide logic
                  }}
                >
                  {transport.uploadFiles?.map((image, index) => (
                    <div
                      key={index}
                      className="flex-shrink-0 px-2 w-full lg:w-1/4" // w-full for mobile, lg:w-1/4 for PC
                    >
                      <img
                        src={image}
                        alt={`Service ${index + 1}`}
                        className="w-full h-48 sm:h-64 object-cover rounded-lg shadow"
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* Right Button */}
              <button
                onClick={nextSlide}
                className="absolute right-0 -mr-5 z-10 rounded-full p-1 bg-gray-100 hover:bg-gray-200 transition shadow"
              >
                <svg
                  width="22"
                  height="16"
                  viewBox="0 0 22 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.7071 8.70711C22.0976 8.31659 22.0976 7.68342 21.7071 7.2929L15.3431 0.928935C14.9526 0.53841 14.3195 0.53841 13.9289 0.928935C13.5384 1.31946 13.5384 1.95262 13.9289 2.34315L19.5858 8L13.9289 13.6569C13.5384 14.0474 13.5384 14.6805 13.9289 15.0711C14.3195 15.4616 14.9526 15.4616 15.3431 15.0711L21.7071 8.70711ZM-1.74846e-07 9L21 9L21 7L1.74846e-07 7L-1.74846e-07 9Z"
                    fill="#7415E2"
                  />
                </svg>
              </button>
            </div>

            {/* Grouped Data Section */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
              {groupedData.map((group, index) => (
                <div
                  key={index}
                  className="bg-white border rounded-lg shadow p-4"
                >
                  <table className="w-full text-sm">
                    <tbody>
                      {group.map((item, idx) => (
                        <tr key={idx} className="border-b last:border-none">
                          <td className="flex items-center gap-2 p-2 font-medium text-gray-700">
                            {item.icon}
                            {item.label}
                          </td>
                          <td className="p-2 text-gray-600">{item.value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ))}
            </div>
          </div>

          {/* Service Type and Availability Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10 mb-20">
            <div className="bg-white rounded-lg p-6 shadow-sm border">
              <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                  />
                </svg>
                Service Type
              </h3>
              <div className="flex justify-center">
                <img src={ambulance} alt="Healthcare" className="w-[130px]" />
              </div>
              <p className="text-center text-xl text-gray-400 tracking-[0.5em] mt-4">
                TRANSPORTATION
              </p>
            </div>

            <div className="bg-white rounded-lg p-6 shadow-sm border flex justify-start gap-10 flex-col">
              <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Availability
              </h3>
              <div className="flex items-center justify-center gap-2 text-4xl">
                <CheckCheck className="w-8 h-8" />
                <span>Available</span>
              </div>
            </div>
          </div>

          {/* newsletter & footer */}
        </div>
        <Newsletter />
        <Footer />
      </div>
    </>
  );
}
